"use client";

import { ArrowDown, Code2 } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactElement, ReactNode } from "react";

const HERO_POINTS: readonly string[] = [
  "100% remote",
  "Flexible hours (core time 9–15 CET)",
  "Autonomous work in a small, lean, customer-oriented team",
];

/** Dark type-first hero for the engineering page. */
export function Engineering2Hero(): ReactElement {
  const t = useTranslations("public.engineering2Hero");
  return (
    <section className="c2-hero">
      <div className="c2-hero-inner">
        <span className="e2-kicker">
          <Code2 size={14} strokeWidth={2.2} aria-hidden={true} />
          {t("engineering")}
        </span>
        <h1 className="c2-hero-title">
          {t.rich("softwareEngineeringAt", {
            accent: (chunks: ReactNode): ReactNode => (
              <span className="e2-accent">{chunks}</span>
            ),
          })}
        </h1>

        <ul className="dvf-facts">
          {HERO_POINTS.map((point: string) => (
            <li className="dvf-fact" key={point}>
              {point}
            </li>
          ))}
        </ul>

        <p className="c2-hero-intro">{t("buildASoftwareThat")}</p>

        <div className="c2-hero-cta">
          <Link href="#jobs" className="e2-hero-btn">
            {t("viewOpenEngineeringRoles")}
            <ArrowDown size={16} strokeWidth={2.2} />
          </Link>
        </div>
      </div>
    </section>
  );
}
